import React from 'react';

import {AppButton} from '@/components/Button';
import {StickyPageLayout} from '@/components/Layout';
import useIsMobileLayout from '@/hooks/layout/useIsMobileLayout';
import appContent from '@/services/content/appContent';
import pushNotificationService from '@/services/pushNotification/pushNotificationService';
import routerService from '@/services/route/routerService';
import {WARNING_BANNER_SOURCE_TYPES, WarningBanners, WarningBannersTop} from '@/views/WarningBanners';

import NotificationSettingsContent from './components/NotificationSettingsContent';
import useNotificationSettingsPage from './useNotificationSettingsPage';

const NotificationSettingsPage = () => {
    const {globalItemDescription, globalItemTitle, globalSectionTitle, title, button} =
        appContent.getPushNotificationsSettingsContent();
    const isMobileLayout = useIsMobileLayout();
    const onBack = isMobileLayout ? () => routerService.goBack() : null;
    const {handleSaveClick, form, isAnyOperationInProgress} = useNotificationSettingsPage();
    const isPushNotificationDisabled =
        !pushNotificationService.checkIfPushNotificationSupported() || isAnyOperationInProgress;

    return (
        <div className='flex h-full w-full flex-col bg-primary-dark-5 ml:bg-romance'>
            <WarningBannersTop
                source={WARNING_BANNER_SOURCE_TYPES.PREFERENCE_CENTER}
                className='ml:left-[var(--sidebar-width)]'
            />
            <StickyPageLayout
                className='items-center'
                desktopClassName='p-16 pb-8 pt-16-hw-offset bg-primary-dark-5 ml:bg-romance'
                mobile
                headerOptions={{
                    onBack,
                    title,
                }}
                contentClassName='flex flex-1 flex-col items-center'
                footer={
                    button?.text && (
                        <AppButton
                            className='mt-0 ml:mt-8 ml:w-[314px]'
                            light
                            primary
                            onClick={handleSaveClick}
                            aria-label={button.alt}
                            disabled={isPushNotificationDisabled}
                            loading={isAnyOperationInProgress}
                        >
                            {button.text}
                        </AppButton>
                    )
                }
            >
                {title && (
                    <div className='w-full'>
                        <h1 className='mt-safe-offset-sticky-header mb-3 px-4 text-start ml:mb-4 ml:mt-0 ml:px-0 ml:text-32 ml:leading-13125'>
                            {title}
                        </h1>
                    </div>
                )}
                <NotificationSettingsContent
                    form={form}
                    sectionHeader={globalSectionTitle}
                    title={globalItemTitle}
                    description={globalItemDescription}
                    isPushNotificationDisabled={isPushNotificationDisabled}
                />
                {isMobileLayout && (
                    <WarningBanners className='mt-8' source={WARNING_BANNER_SOURCE_TYPES.PREFERENCE_CENTER} />
                )}
            </StickyPageLayout>
            {!isMobileLayout && <WarningBanners source={WARNING_BANNER_SOURCE_TYPES.PREFERENCE_CENTER} />}
        </div>
    );
};

export default NotificationSettingsPage;
